import PropTypes from 'prop-types'
import { useState } from 'react'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDTextarea from '@/shared/components/SDComponents/SDTextarea/SDTextarea'
import { useTranslation } from 'react-i18next'
import {
  QuestionText,
  FeedbackButtonsRow,
  FeedbackButton, SuccessContainer, SuccessMessage
} from './styled-components'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import IconCheckCircle from '@/shared/icons/NewDesign/IconCheckCircle'
import {
  selectCommonFormConfigurationData
} from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSelectors'
import { selectPageConfigurationData } from '@/store/PageConfiguration/PageConfigurationSelectors'
import { useDispatch, useSelector } from 'react-redux'
import useHttp from '@/shared/hooks/useHttp'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { updateCustomerData } from '@/containers/SubscriptionFormPage/SubscriptionFormSlice'

const FeedbackModalContent = ({ onClose }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [comment, setComment] = useState('')
  const [feedback, setFeedback] = useState(null)
  const [isSending, setIsSending] = useState(false)
  const [sent, setSent] = useState(false)
  const { save_feedback_url: saveFeedbackUrl } = useSelector(selectPageConfigurationData)
  const { id } = useSelector(selectCommonFormConfigurationData)
  const { lang } = useSelector(selectAuthData)
  const { sendRequest, getConfig } = useHttp()
  const needsComment = feedback === 0
  const sendDisabled =
    isSending ||
    sent ||
    (feedback === 0 && comment.trim() === '')

  const showTextarea = needsComment && !sent
  const showButton = feedback !== null && !sent

  const handleClick = () => {
    setIsSending(true)
    const headers = getConfig('POST')
    headers.headers['Content-Type'] = 'application/json'
    headers.body = JSON.stringify({
      feedback,
      comment,
      subscriptionId: id,
    })
    sendRequest(saveFeedbackUrl + '?lang=' + lang, headers, () => {
      setIsSending(false)
      setSent(true)
      dispatch(updateCustomerData({hasAlreadyVotedFeedback: true}))
    })
  }

  return (
      <SuccessContainer>
        <IconCheckCircle size={80} color='green' />
        <SuccessMessage>{t('subscriptionForm:header.modal_save_send.save_success')}</SuccessMessage>
        <QuestionText>{t('subscriptionForm:header.modal_save_send.feedback_text')}</QuestionText>

        <FeedbackButtonsRow>
          <FeedbackButton
            $active={feedback === 1}
            onClick={() => setFeedback(1)}
            disabled={sent}
          >
            👍 {t('common:yes_text')}
          </FeedbackButton>
          <FeedbackButton
            $active={feedback === 0}
            onClick={() => setFeedback(0)}
            disabled={sent}
          >
            👎 {t('common:no_text')}
          </FeedbackButton>
        </FeedbackButtonsRow>

        <SDTextarea
          value={comment}
          onChange={event => setComment(event.target.value)}
          placeholder={t('subscriptionForm:header.modal_save_send.feedback_placeholder')}
          disabled={sent}
          hidden={!showTextarea}
        />

        <SDButton
          size="compact"
          kind="primary"
          isLoading={isSending}
          disabled={sendDisabled}
          onClick={handleClick}
          hidden={!showButton}
        >
          {t('subscriptionForm:header.modal_save_send.feedback_send')}
        </SDButton>

        <SDNotification
          hidden={!sent}
          centerText
          primaryText={t('subscriptionForm:header.modal_save_send.feedback_thanks')}
        />

        <SDButton
          size="compact"
          kind="secondary"
          onClick={onClose}
          style={{ marginTop: '1rem' }}
          hidden={!sent}
        >
          {t('common:close')}
        </SDButton>

      </SuccessContainer>
  )
}

FeedbackModalContent.propTypes = {
  onClose: PropTypes.func.isRequired,
}
export default FeedbackModalContent
